import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import { HttpMethod, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
export class ListAwsRdsInstanceClassesApiRequestFactory extends BaseAPIRequestFactory {
    async listAwsRdsInstanceClasses(projectId, engine, engineVersion, accountId, region, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "projectId");
        }
        if (engine === null || engine === undefined) {
            throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "engine");
        }
        if (engineVersion === null || engineVersion === undefined) {
            throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "engineVersion");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "accountId");
        }
        if (region === null || region === undefined) {
            throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "region");
        }
        const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/regions/{region}/aws-rds-instance-classes'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'region' + '}', encodeURIComponent(String(region)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (engine !== undefined) {
            requestContext.setQueryParam("engine", ObjectSerializer.serialize(engine, "AwsRdsEngine", ""));
        }
        if (engineVersion !== undefined) {
            requestContext.setQueryParam("engineVersion", ObjectSerializer.serialize(engineVersion, "string", "tobedefined"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class ListAwsRdsInstanceClassesApiResponseProcessor {
    async listAwsRdsInstanceClassesWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "RestoreRdsInstanceClasses", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
